import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { Router } from "@angular/router";
import { ToastrManager } from "ng6-toastr-notifications";
import { dataType } from "../dataType";

@Component({
  selector: "app-create-bucket",
  templateUrl: "./create-bucket.component.html",
  styleUrls: ["./create-bucket.component.css"]
})
export class CreateBucketComponent {
  public data: any = {};
  public ACL = [
    {name: "private"},
    {name:"public-read"},
    {name:"public-read-write"},
    {name:"aws-exec-read"},
    {name:"authenticated-read"},
    {name:"bucket-owner-read"},
    {name:"bucket-owner-full-control"},
    {name:"log-delivery-write"}
  ];

  constructor(
    private dataService: DataService,
    private router: Router,
    private toastr: ToastrManager
  ) {}

  addBucket() {
    this.save();
  }

  private save(): void {
    this.data["region"] = localStorage.getItem("region");
    console.log(this.data);
    this.dataService.addBucket(this.data).subscribe((Data: any) => {
      if (typeof Data == "string") {
        var newData = JSON.parse(Data);
      } else {
        var newData = Data;
      }
      console.log(newData);
      if (newData.Status == "Error") {
        console.log(newData.Error.message);
        // alert(newData.Error.message)
        this.toastr.errorToastr(newData.Error.message, "oops!");
      } else if (newData.Status == "Success") {
        // alert("Bucket Created Successfully")
        this.toastr.successToastr("Bucket Created Successfully", "Success!");
        this.router.navigate(["/buckets"]);
      }
    });
  }
}
